module.exports = __webpack_public_path__ + "static/media/comorbity_banner.3d1b1095.svg";